module.exports = __webpack_public_path__ + "7772e15dfa00cc565dcefe20cb2bf2db.svg";


//////////////////
// WEBPACK FOOTER
// ./res/images/logo/nb/apple_store.svg
// module id = 845
// module chunks = 0